import { render, staticRenderFns } from "./FormFieldReadOnly.vue?vue&type=template&id=3d4e5484&scoped=true&"
import script from "./FormFieldReadOnly.vue?vue&type=script&lang=js&"
export * from "./FormFieldReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldReadOnly.vue?vue&type=style&index=0&id=3d4e5484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e5484",
  null
  
)

export default component.exports